export const onLocalEnvironment: boolean = import.meta.env.VITE_SENTRY_ENV === 'Développement';

export const apiBaseURL: string = import.meta.env.VITE_API_BASE_URL;

// Strapi returns a relative URL on local env & an absolute URL on production/staging
export const fileBaseURL: string = onLocalEnvironment ? apiBaseURL : '';
